import { useFirstPromoter } from "@/feature/firstPromoter/hooks/useFirstPromoter.hook";
import EmailStep from "../components/auth/steps/EmailStep";
import { useMetaPixel } from "../hooks/useMetaPixel";
import { useSearchParams } from "react-router-dom";


const LandingOfferPage = () => {
  const [searchParams] = useSearchParams();
  const { trackEvent } = useMetaPixel();

  useFirstPromoter(false);

  const couponCode = searchParams.get("coupon_code");

  const handlePagoIniciado = () => {
    trackEvent("InitiateCheckout", { value: 39.99, currency: "USD" });
  };

  return (
    <div className="flex flex-col items-center justify-center h-screen bg-[#4f47e5]">
      <EmailStep onClose={() => { }} email={''} onNext={() => { }} offer={true} handlePagoIniciado={handlePagoIniciado} couponCode={couponCode || undefined} />
    </div>
  );
};

export default LandingOfferPage;